import { getConfig } from '@/utils/config';

export const resolveLogoUrl = (isDarkMode: boolean) => {
  const config = getConfig();

  const externalDarkLogoUrl = config.branding?.logo?.darkUrl;
  const externalLightLogoUrl = config.branding?.logo?.lightUrl;

  if (isDarkMode) {
    if (externalDarkLogoUrl) {
      return externalDarkLogoUrl;
    }

    return '/logo/embraceable_logo_dark.svg';
  }

  if (externalLightLogoUrl) {
    return externalLightLogoUrl;
  }
  return '/logo/embraceable_logo_light.svg';
};
